import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConfigState } from '../../models';

const initialState: ConfigState = {
  allowedRoleAssignmentEmailDomains: [],
  langFallBack: {},
  langWhiteList: [],
  api: '',
  countries: [],
  www: '',
  passwordRules: {
    requirements: [],
    rules: {},
  },
  regionalMap: {},
  regions: {},
  registrationRules: [],
  countryDefault: '',
  documents: {},
};

export const configSlice = createSlice({
  name: 'config',
  initialState,
  reducers: {
    update: (state, action: PayloadAction<ConfigState>) => {
      Object.assign(state, action.payload);
      state.countries = Object.entries(state.regions)
        .map(([, value]) => {
          return value.countries;
        })
        .reduce((prev, cur) => {
          return [...prev, ...cur];
        }, []);
    },
  },
});

export const { update } = configSlice.actions;
export default configSlice.reducer;

// export const configReducer = (state = initialState, action: ConfigActions): ConfigState => {
//   switch (action.type) {
//     case CONFIG_UPDATE:
//       return {
//         ...state,
//         ...action.config,
//       };

//     default:
//       return state;
//   }
// };
